<template>
  <div :class="` colapse-section ${open?'':'closed'}`">
      <div class="header" @click="change">
        <h3>{{label}}</h3> 
        <div>
            <b-icon class="my-icon interactive" icon="sort-down" >
            </b-icon>
       </div>
      </div>
      <div class="content">
          <slot></slot>
      </div>
      <hr>
  </div>
</template>

<script>
export default {
    name:"Colapse",
    props:{
        label:{
            type:String,
            required:true
        }
    },
    data(){
        return{
            open:false
        }
    },
    methods:{
        change(){
            this.open = !this.open
        }
    }
    
}
</script>

<style lang="scss" scoped>
@import '@/assets/vars.scss';
.colapse-section{
  padding: 0px 16px;
    .header{
        display:flex;
        justify-content: space-between;
    }

    .my-icon{
        transition: transform 0.5s ease-in-out; 
        transform: rotate(180deg);     
    }

    .content{ 
        max-height: 150vh;
        transition: all 0.5s ease-in-out;
        overflow-y: hidden;
        overflow-x: auto;
    }
}

.closed{
    .content{
        max-height: 0px;     
        margin: 0;
    }
    .my-icon{
        transform: rotate(0deg);    
    }
}

h3{

    margin-top: 5px;
    font-weight: bold;
    font-size: 20px;
    color: $black;
    font-family: Montserrat;
}

</style>